// Split delivery (Yes / No) is mandatory, both addresses are mandatory when "Yes".
// Same rules as the backend (helpers/splitDeliveryValidation.js in apilavender),
// checked before any save popup so the form never submits half filled.
export const getSplitDeliveryErrors = (info = {}) => {
  const errors = {};
  if (info.split_delivery !== "Yes" && info.split_delivery !== "No") {
    errors.split_delivery = "Please select split delivery Yes or No";
  }
  if (info.split_delivery === "Yes") {
    if (!String(info.instruments_delivery_address || "").trim()) {
      errors.instruments_delivery_address = "Please enter the instruments delivery address";
    }
    if (!String(info.implants_delivery_address || "").trim()) {
      errors.implants_delivery_address = "Please enter the implants delivery address";
    }
  }
  return errors;
};
